<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0 mb-16">
    <slot />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <ListCreator
        v-model="adventureSitterSupplies"
        header="List all of the supplies you’ll bring"
        :max-characters="suppliesLengthConstraint.max"
        :max-items="suppliesCountConstraint.max"
        class="mb-48"
      />
      <ListCreator
        v-model="adventureParentSupplies"
        header="List the items you want parents to provide"
        :max-characters="suppliesLengthConstraint.max"
        :max-items="suppliesCountConstraint.max"
        class="mb-36"
      />
      <StickyButton :value="isEdit ? 'Save' : 'Next'" type="submit" />
    </form>
    <NoteBox v-if="noteBoxMessage" header="Things to Consider" :body="noteBoxMessage" />
  </div>
</template>

<script lang="ts">
// components
import ListCreator from '../../../components/list_creator/ListCreator.vue';
import NoteBox from '../../../components/note_box/NoteBox.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';

export default {
  name: 'Supplies',
  components: { ListCreator, NoteBox, StickyButton },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      adventureSitterSupplies: this.$store.getters['adventures/sitterSuppliesList'],
      adventureParentSupplies: this.$store.getters['adventures/parentSuppliesList'],
    };
  },
  computed: {
    validSupplies(): boolean {
      const { adventureSitterSupplies, adventureParentSupplies } = this.suppliesWithoutEmpties;
      if (adventureSitterSupplies.length > 0 && adventureParentSupplies.length > 0) return true;
      return false;
    },
    suppliesWithoutEmpties(): { adventureSitterSupplies; adventureParentSupplies } {
      return {
        adventureSitterSupplies: this.adventureSitterSupplies
          .filter((supply) => supply)
          .map((supply) => ({
            item: supply,
          })),
        adventureParentSupplies: this.adventureParentSupplies
          .filter((supply) => supply)
          .map((supply) => ({
            item: supply,
          })),
      };
    },
    noteBoxMessage(): string {
      return this.adventureMetaData?.categories?.[0].suppliesExample || '';
    },
    suppliesLengthConstraint(): any {
      return this.findConstraint('SUPPLIES_LENGTH');
    },
    suppliesCountConstraint(): any {
      return this.findConstraint('SUPPLIES_COUNT');
    },
  },
  methods: {
    submitForm() {
      if (this.validSupplies) {
        this.setSupplies();
      } else {
        this.$emit('alert', 0, 'At least one item for each question is required.');
        this.scrollToTop();
      }
      return false;
    },
    async setSupplies() {
      await this.$store.dispatch('adventures/updateStore', this.suppliesWithoutEmpties);
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/rate',
      });
    },
    findConstraint(field: string) {
      return this.adventureMetaData?.constraints.find((constraint) => constraint.field === field) || {};
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
